import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AutoComplete, Input, Button } from "antd";
import type { SelectProps } from "antd/es/select";
import { debounce } from "lodash-es";
import Parser from "html-react-parser";
import EcologicalTabs from "@/components/EcologicalTabs";
import api from "@/api";
import { UserChangeTabs } from "@/hooks";
import { publicPath } from "@/utils/base";
import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";

import dataJson from "@/../public/data.json";

import "./index.less";
import { goLogin } from "@/utils";
const prefix = "documentResources";

function Ecological() {
  const { stay_tuned, document_resources } = dataJson;

  const [options, setOptions] = useState<SelectProps<object>["options"]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [key, setKey] = useState<string | null>("");
  const [params, setParams] = useSearchParams();

  const { current, tabsChange } = UserChangeTabs(prefix, document_resources, key);

  const searchResult: (any: string) => void = (query: string) => {
    api
      .documentQuery({ keyword: query, limit: 30, page: 1 })
      .then((res: any) => {
        const resData = res.data;
        const resList = resData.datas.map((item: any) => {
          return {
            value: item.url,
            label: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <span
                  style={{ width: "30%", marginRight: 100 }}
                  className="one-line-ellipsis"
                  title={item.navigationBar.replace(/<[^>]+>/g, "")}
                >
                  {item.navigationBar}
                </span>
                <span
                  style={{ width: "60%" }}
                  className="one-line-ellipsis"
                  title={item.highlightContent.replace(/<[^>]+>/g, "")}
                >
                  {Parser(item.highlightContent)}
                </span>
              </div>
            ),
          };
        });
        setOptions(resList);
      })
      .catch(() => {
        setOptions([]);
      });
  };

  const onSelect = (value: string) => {
    setSearchValue("");
    // navigate(`${publicPath}/iframe-document?url=${value}`);
    window.location.href = value;
  };

  const handleSearch = (e: any) => {
    e ? searchResult(e) : setOptions([]);
  };

  useEffect(() => {
    const key = params.get("key");
    setKey(key);
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-banner`} style={{ backgroundImage: `url(${document_resources.banner_bg_img})` }}>
        <div className={`${prefix}-title`}>{document_resources.title}</div>
        <div className={`${prefix}-search`}>
          <AutoComplete
            value={searchValue}
            options={options}
            maxLength={100}
            onSelect={onSelect}
            onSearch={debounce(handleSearch, 300)}
            onChange={(e: any) => {
              setSearchValue(e);
            }}
            className={`${prefix}-search-autoComplete`}
          >
            <Input size="large" placeholder="请输入关键词搜索文档" allowClear className={`${prefix}-search-input`} />
          </AutoComplete>
        </div>
      </div>
      <EcologicalTabs current={current} list={document_resources.list} onChange={tabsChange} />

      <div className={`${prefix}-content`}>
        {document_resources.list.map((item: any) => {
          return (
            <div key={item.key} className={`${prefix}-content-inner`}>
              <div className={`${prefix}-module`} id={`${prefix}-module-${item.key}`}>
                <div className={`${prefix}-module-title`}>{item.title}</div>
                <div className={`${prefix}-module-cards`}>
                  {item.list.map((ele: any) => {
                    return ele?.describe && ele.btns?.length ? (
                      <div
                        className={`${prefix}-card`}
                        style={{ backgroundImage: `url(${document_resources.card_bg_img})` }}
                        key={ele.key}
                      >
                        <div className={`${prefix}-card-title`}>{ele.title}</div>
                        <div className={`${prefix}-card-describe`}>{ele.describe}</div>
                        <div className={`${prefix}-card-btns`}>
                          {ele.btns.map((e: any, i: number) => {
                            return (
                              <Button
                                type="primary"
                                ghost
                                key={e.key}
                                disabled={!e.url}
                                onClick={() => {
                                  if (!!e.needLogin && !getAuthTokenValue("Authorization")) {
                                    goLogin();
                                  } else {
                                    window.open(publicPath + e.url, "_blank");
                                  }
                                }}
                                className={`${prefix}-card-btn`}
                              >
                                {e.label}
                              </Button>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`${prefix}-stay_tuned`}
                        style={{ backgroundImage: `url(${document_resources.card_bg_img})` }}
                        key={ele.key}
                      >
                        <div className={`${prefix}-card-title`}>{ele.title}</div>
                        <div className={`${prefix}-card-empty`}>{stay_tuned}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Ecological;
